<template>
  <div v-if="!loading">
    <NowPlaying :playing="playing"></NowPlaying>
    <RadioStats :repeatinfo="repeatInfo" :stats="radioStats"></RadioStats>
    <TrackList id="recent" header="Recently Played" :tracks="recentlyPlayed" :skipfirst="true"></TrackList>
    <TrackList id="popular" header="Popular Tracks" :tracks="popularTracks" :longdate="true"></TrackList>
  </div>
  <div v-else>
    <div class="loading">
      <span class="fa fa-spinner fa-spin fa-2x"></span>
      <h1>Connecting to radio... please wait...</h1>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/globals/Navbar";
import NowPlaying from "@/components/globals/NowPlaying";
import RadioStats from "@/components/globals/RadioStats";
import TrackList from "@/components/globals/TrackList";

export default {
  name: "home",
  components: {
    Navbar,
    NowPlaying,
    RadioStats,
    TrackList
  },

  props: {},

  data() {
    return {
      playing: {},
      repeatInfo: {},
      radioStats: {
        currentListeners: 0,
        peakListeners: 0,
        averageListenTime: 0,
        streamStatus: 0
      },
      recentlyPlayed: [],
      popularTracks: [],
      loading: true,
      intervals: {
        playing: null,
        stats: null,
        history: null,
        popular: null
      }
    };
  },

  mounted() {
    this.fetchPlayingTrack();
    this.fetchRadioStats();
    this.fetchHistory();
    this.fetchPopular();

    this.intervals.playing = setInterval(this.fetchPlayingTrack, 5 * 1000);
    this.intervals.stats = setInterval(this.fetchRadioStats, 30 * 1000);
    this.intervals.history = setInterval(this.fetchHistory, 60 * 1000);
    this.intervals.popular = setInterval(this.fetchPopular, 120 * 1000);

    // init winapp
    this.$nextTick(() => {
      this.$winapp.init();
    });
  },

  beforeDestroy() {
    var intervalKey = undefined,
      interval = undefined;
    for (intervalKey in this.intervals) {
      if (
        this.intervals.hasOwnProperty(intervalKey) === false ||
        !(interval = this.intervals[intervalKey])
      ) {
        continue;
      }

      clearInterval(interval);
    }
  },

  methods: {
    fetchPlayingTrack() {
      this.$http
        .get("https://radioapi.madnight.co.uk/shoutcast-vue.php")
        .then(response => {
          if (
            response.data == undefined ||
            response.data == null ||
            response.status !== 200
          )
            return;

          this.repeatInfo = response.data.repeat_info;

          if (
            response.data.track_info.artist !== this.playing.artist ||
            response.data.track_info.track !== this.playing.track ||
            response.data.track_info.game !== this.playing.game
          ) {
            this.playing = response.data.track_info;
          }

          // figure out if we should change the repeat record
          var lastRepeat = Date.now() - this.repeatInfo.last_repeat * 1000;
          lastRepeat /= 1000;

          // if it's a new record start counting the repeat record up
          if (lastRepeat > this.repeatInfo.no_repeat_record) {
            this.repeatInfo.no_repeat_record = lastRepeat;
          }

          this.loading = false;
        });
    },

    fetchRadioStats() {
      this.$http
        .get("https://radiostats.madnight.co.uk/stats?json=true")
        .then(response => {
          if (
            response.data == undefined ||
            response.data == null ||
            response.status !== 200
          )
            return;

          response = response.data;

          this.radioStats = {
            currentListeners: response.currentlisteners,
            peakListeners: response.peaklisteners,
            averageListenTime: response.averagetime,
            streamStatus: response.streamstatus
          };
        });
    },

    fetchHistory() {
      this.$http
        .get("https://radioapi.madnight.co.uk/history.php?type=json")
        .then(response => {
          if (
            response.data == undefined ||
            response.data == null ||
            response.status !== 200
          )
            return;

          response = response.data;

          this.recentlyPlayed = response.history;
        });
    },

    fetchPopular() {
      this.$http
        .get("https://radioapi.madnight.co.uk/popular.php")
        .then(response => {
          if (
            response.data == undefined ||
            response.data == null ||
            response.status !== 200
          )
            return;

          response = response.data;

          this.popularTracks = response.popular_tracks;
        });
    }
  }
};
</script>

<style lang="scss">
.loading {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 1.5rem;
  font-weight: bold;
  justify-content: center;
  padding: 20px 0;
  width: 100%;

  .fa {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1de8bb09